import React from "react";
import moment from "moment-timezone";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import getSymbolFromCurrency from "currency-symbol-map";

function numberWithCommas(x) {
    return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const MockDocTableColumn = (language,userinfo,apidata) => {
    let columns = [
        {
            Header: language.INVOICE_INVOICE_NO,
            accessor: (d) => (
                <>
                    <span>{d.invoice_country === "IND-EXP"?d.export_no:d.invoicenumber}</span>
                    <br />
                    <span className="text-muted small">
                        {/* {d.date} */}
                        { d.date ? moment.tz(d.date, userinfo.timezone ? userinfo.timezone : Intl.DateTimeFormat().resolvedOptions().timeZone).format("YYYY-MM-DD HH:mm:ss") : "-"}
                    </span>
                </>
            ),
            className: "align-middle text-center",
        },
        {
            Header:language.INVOICE_TOTALPCS,
            className:"text-center align-middle mr-3",
            accessor: "total_pcs",
        },
        {
            Header:language.INVOICE_TOTALCARAT,
            className:"text-center align-middle mr-3",
            accessor: "total_carat",
            Cell: (row) => {
                return (
                    <>
                        <span>{row.value}</span>
                    </>
                );
            },
        },
        {
            Header: "Purchase Price",
            accessor: (d) => (
                <>
                    <span className="font-weight-bold">
                        {d["OurPriceSymbol"]}{numberWithCommas(parseFloat(d["OurPrice"]))}
                    </span>{" "}
                    <br />
                    {/* <span className="text-muted small">
                        ₹/CT {numberWithCommas(parseFloat(d["INR_CT"]))}
                    </span> */}
                </>
            ),
            className: "text-center pr-12 align-middle",
        },
    ]
    if(apidata?.[0]?.displayExchange){
        columns.push({
            Header: "Exchange Price",
            accessor: (d) => (
                    d.OurPriceExchangeSymbolName && d.OurPriceExchangeSymbolName !== "USD" ?
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip"> Ex. Rate : {d.OurPriceExchangeSymbolName} { d.OurPriceExchangeSymbol}{d.oh_global_other_cgs_ex_rate}</Tooltip>}
                        >
                            <div className="font-weight-bold">
                                { d.OurPriceExchangeSymbol}{numberWithCommas(parseFloat(d["OurPriceExchange"]))}
                            </div>
                        </OverlayTrigger>
                    :"-"
            ),
            className: "text-center pr-12 align-middle",
        })
    }
    columns.push({
        Header: language.INVOICE_STATUS,
        accessor: "shipping_status",
        className: "text-center align-middle",
        Cell: (row) => {
            return (
                <div>
                    <div
                        className={`label ${
                                  row.value === 1 ? "label-primary"
                                : row.value === 0 ? "label-warning"
                                : row.value === "Return" ? "label-danger" 
                                : ""
                        } label-inline  mr-2`}
                    >
                        {row.value === 0?"Pending":row.value === 1?"Shipped":"Return"}
                    </div>
                </div>
            );
        },
    },
    {
        Header:language.INVOICE_CARRIER,
        className:"text-center align-middle mr-3",
        accessor: "shippingNew",
    })
    return columns
};
